import api from 'utils/apiClient';

export const getComplaints = (params) => {
  return api.get('/complaints', { params });
};

export const resolveComplaint = (data) => {
  return api.patch('/complaints/resolve', data, {
    headers: {
      'Content-Type': 'application/merge-patch+json',
    },
  });
};
